import { Select, Button } from "antd";
import React, { Component } from "react";

export default class QuyHoach extends Component {
  constructor(props) {
    super(props);

    this.state = {
      listQuan: this.props.listQuan,
      listPhuong: this.props.listPhuong,
      listDuAn: this.props.listDuAn,

      selectedQuan: undefined,
      selectedPhuong: undefined,
      selectedDuAn: undefined,
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.listQuan !== this.props.listQuan) {
      this.setState({ listQuan: this.props.listQuan });
    }

    if (prevProps.listPhuong !== this.props.listPhuong) {
      this.setState({ listPhuong: this.props.listPhuong });
    }

    if (prevProps.listDuAn !== this.props.listDuAn) {
      this.setState({ listDuAn: this.props.listDuAn });
    }
  }

  onChangeQuan(value) {
    let listPhuong = this.props.listPhuong.slice();
    listPhuong = listPhuong.filter((e) => e.MaQuan == value);

    let listDuAn = this.props.listDuAn.filter((e) => e.IDHuyen == value);

    this.setState({
      selectedQuan: value,
      selectedPhuong: undefined,
      selectedDuAn: undefined,
      listPhuong: listPhuong,
      listDuAn: listDuAn,
    });
  }

  onChangePhuong(value, option) {
    let listPhuong = this.props.listPhuong.slice();
    listPhuong = listPhuong.filter((e) => e.MaQuan == option.IDQuan);
    let selectedQuan = this.state.listQuan.filter(
      (e) => e.MAHUYEN == option.IDQuan
    );
    let listDuAn = this.props.listDuAn.filter((e) => e.Maphuong == value);
    this.setState({
      selectedQuan:
        selectedQuan && selectedQuan.length !== 0
          ? selectedQuan[0].MAHUYEN
          : undefined,
      selectedPhuong: value,
      selectedDuAn: undefined,
      listPhuong: listPhuong,
      listDuAn: listDuAn,
    });
  }

  onChangeDuAn(value, option) {
    let selectedPhuong = option.idphuong;
    let selectedQuan = option.idquan !== null ? `${option.idquan}` : undefined;

    this.setState({
      selectedDuAn: value,
      selectedPhuong: selectedPhuong,
      selectedQuan: selectedQuan,
    });
  }

  onResetButton() {
    this.setState({
      listQuan: this.props.listQuan,
      listPhuong: this.props.listPhuong,
      listDuAn: this.props.listDuAn,
      selectedQuan: undefined,
      selectedPhuong: undefined,
      selectedDuAn: undefined,
    });
  }

  onSearch() {
    let data = {
      selectedQuan: this.state.selectedQuan,
      selectedPhuong: this.state.selectedPhuong,
      selectedDuAn: this.state.selectedDuAn,
    };
    this.props.onSearch(data);
  }

  render() {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          height: "100%",
        }}
      >
        <div>
          <div className="group">
            <div className="gr-title">
              {/* <div className="required">*</div> */}
              <div className="text">Quận/Huyện</div>
            </div>

            <div className="gr-body">
              <Select
                className="select"
                showSearch
                value={this.state.selectedQuan}
                onChange={(value) => this.onChangeQuan(value)}
                optionFilterProp = "name"
              >
                {this.state.listQuan.map((e, i) => (
                  <Select.Option value={e.MAHUYEN} key={i} name = {e.TENHUYEN}>
                    {e.TENHUYEN}
                  </Select.Option>
                ))}
              </Select>
            </div>
          </div>

          <div className="group">
            <div className="gr-title">
              {/* <div className="required">*</div> */}
              <div className="text">Phường/Xã</div>
            </div>

            <div className="gr-body">
              <Select
                className="select"
                showSearch
                onChange={(value, option) => this.onChangePhuong(value, option)}
                value={this.state.selectedPhuong}
                optionFilterProp = "name"
              >
                {this.state.listPhuong.map((e, i) => (
                  <Select.Option value={e.MaPhuong} IDQuan={e.MaQuan} key={i} name = {e.TenPhuong}>
                    {e.TenPhuong}
                  </Select.Option>
                ))}
              </Select>
            </div>
          </div>

          <div className="group">
            <div className="gr-title">
              <div className="required">*</div>
              <div className="text">Tên dự án</div>
            </div>

            <div className="gr-body">
              <Select
                className="select"
                showSearch
                onChange={(value, option) => this.onChangeDuAn(value, option)}
                value={this.state.selectedDuAn}
              >
                {this.state.listDuAn.map((e, i) => (
                  <Select.Option
                    value={e.Tendoan}
                    idquan={e.IDHuyen}
                    idphuong={e.Maphuong}
                    key={i}
                  >
                    {e.Tendoan}
                  </Select.Option>
                ))}
              </Select>
            </div>
          </div>
        </div>

        <div style={{ display: "flex", justifyContent: "center" }}>
          <Button
            type="primary"
            className="button"
            onClick={() => {
              this.onResetButton();
            }}
          >
            Tìm mới
          </Button>
          <Button
            type="primary"
            className="button"
            onClick={() => {
              this.onSearch();
            }}
            disabled={
              this.state.selectedQuan &&
              this.state.selectedPhuong &&
              this.state.selectedDuAn
                ? false
                : true
            }
          >
            Tìm kiếm
          </Button>
        </div>
      </div>
    );
  }
}
